import React from 'react'
import ParentPosts from "../Components/ParentPosts";

const ParentForumPage = () => {
  return (
    <>
    <div>
    
        <div />
            <h2 > Parent Community </h2>
            <h6 className='text-muted'>It takes a village! </h6>
            <hr/>
        </div>
        
        <ParentPosts/>
    </>
  )
}

export default ParentForumPage